export enum MenuPositionType {
    Undefined,
    Content,
    Banner
}
